module.exports = __webpack_public_path__ + "static/media/Ogg-Regular.4f5d86f1.ttf";